exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.promo-info h2{\n  font-size: 100%;\n}\n", ""]);

// exports
